import HeartIcon from "@components/icons/heart-icon";
import { useSx } from "dripsy";
import AnimatedPressable from "@components/animated-pressable";
import * as React from "react";
import FavouriteModal from "@features/favourite/favourite-modal/favourite-modal";
import useModalState from "@hooks/useModalState";
import type { ProductType } from "@type/global";
import { useIsProductInOneOfTheWishlists } from "@features/favourite/wishlist-store";

function FavouriteModalButton({ product }: { product: ProductType }) {
  const sx = useSx();
  const { visible, onClose, onOpen } = useModalState();
  const isInWishList = useIsProductInOneOfTheWishlists(product.pid);

  return (
    <>
      <AnimatedPressable
        hitSlop={{ top: 10, right: 10, bottom: 10, left: 10 }}
        style={sx({
          borderRadius: 100,
          width: 36,
          height: 36,
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-around",
        })}
        onPress={onOpen}
        animate={React.useMemo(
          () =>
            ({ hovered, pressed }) => {
              return {
                transform: [{ scale: hovered || pressed ? 1.05 : 1 }],
              };
            },
          []
        )}
      >
        <HeartIcon color="$text" size={20} isSelected={isInWishList} />
      </AnimatedPressable>
      {visible && <FavouriteModal product={product} onClose={onClose} />}
    </>
  );
}

export default FavouriteModalButton;
